module.exports = __webpack_public_path__ + "media/components/src/assets/images/button/button_2-58d89f6e58c1029ff33a7741a9d49b70.jpg";